import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconTimeline = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <path d='m3 17 5.5-5.5 4 4L21 7' />
      <circle cx='3' cy='17' r='0.6' />
    </g>
  </SDIcon>
)

export default IconTimeline
